export default __webpack_public_path__ + "b271ff66e65053238421ab0673fb6edf.png";